import React from 'react';
function PlusInCircle({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M12.25 22C17.7728 22 22.25 17.5228 22.25 12C22.25 6.47715 17.7728 2 12.25 2C6.72715 2 2.25 6.47715 2.25 12C2.25 17.5228 6.72715 22 12.25 22Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12.25 8V16" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.25 12H16.25" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default PlusInCircle;
